export default __webpack_public_path__ + "5a4bde3a90e675c66c07a3f6890e9f5b.svg";